<template>
  <div>
    <!-- <label class="label">{{ param.name }}</label> -->
    <!-- <div class="control"> -->
    <!--
     0: 텍스트
     1: 정수
     2: 실수
     3: 선택형
     4: 지역
     5: 주소
     6: 직선형 스탭
     -->
    <!--<lp-editor v-if="param.param_type===0"
               :text.sync="param.value_text"></lp-editor>-->

    <textarea v-if="param.param_type===0"
           class="input"
           :value="param.value_text"
            @input="e => param.value_text= e.target.value"></textarea>

    <input v-else-if="param.param_type===1"
           class="input"
           :value="param.value_integer"
           @input="e => param.value_integer= e.target.value"
           type="number" maxlength="10">

    <input v-else-if="param.param_type===2"
           class="input"
           :value="param.value_float"
           @input="e => param.value_float= e.target.value"
           type="number" maxlength="10">

    <lp-check-group v-else-if="param.param_type===3 && param.format==='CCheckboxGroup'"
                    :list="param.choice_items"
                    :data="param.value_select"
                    value_name="id"
                    label_name="name"
                    style="margin-bottom:12px"></lp-check-group>

    <lp-radio v-else-if="param.param_type===3 && ['CRadiobuttonGroup', 'CGender'].indexOf(param.format)>-1"
              :data="param.choice_items"
              :val="selectedRadioValue(param.value_select)"
              @onSelect="res=>selectRadioValue(res, param)"
              value_name="id"
              label_name="name"
              style="margin-bottom:12px"></lp-radio>

    <lp-multiple-color-input v-else-if="param.param_type===3 && param.format==='CColorPicker'"
                             :list="param.choice_items"
                             :data="param.value_select"
                             value_name="id"
                             label_name="name"></lp-multiple-color-input>

    <lp-region-drop-down v-else-if="param.param_type===4"
                         :data.sync="param.value_region"
                         style="margin-bottom:12px"></lp-region-drop-down>

    <!-- 주소 -->
    <lp-address v-else-if="param.param_type===5"
                :data.sync="param.value_address"
                style="margin-bottom:12px"></lp-address>

    <!-- 직선형 스탭 -->
    <lp-linear v-else-if="param.param_type===6"
               :data.sync="param.value_linear" :options="param.options"
               style="margin-bottom:12px"></lp-linear>

    <admin-date-picker v-else-if="param.param_type===7"
                       :data="param.value_date"
                       @setDate="selDate"
                       style="margin-bottom:12px"></admin-date-picker>
    <input-file :value.sync="param.file_ext"
                @setValue="val=>param.value_files=val"
                v-else-if="param.param_type===8"
                style="margin-bottom:12px"></input-file>

    <!--<old-input-file :files.sync="param.value_files"
                @remove="idx=>removeIndex(param.value_files, idx)"
                v-else-if="param.param_type===8"
                    style="margin-bottom:12px"></old-input-file>-->

    <time-picker  v-else-if="param.param_type===9" width="140"
                       :value.sync="param.value_time"
                  style="margin-bottom:12px"></time-picker>

    <admin-date-picker v-else-if="param.param_type===10"
                       type="datetime"
                       :data="param.value_date_time"
                       @setDate="selDateTime"
                       style="margin-bottom:12px"></admin-date-picker>

    <admin-date-picker v-else-if="param.param_type===11"
                       type="daterange"
                       :data="param.value_date_range"
                       @setDate="selDateRange"
                       style="margin-bottom:12px"></admin-date-picker>

    <admin-date-picker v-else-if="param.param_type===12"
                       type="datetimerange"
                       :data="param.value_date_time_range"
                       @setDate="selDateTimeRange"
                       style="margin-bottom:12px"></admin-date-picker>

    <!-- 주소 리스트형 -->
    <lp-address-list  v-else-if="param.param_type===13"
                      :data.sync="param.value_address_list"
                      style="margin-bottom:12px"></lp-address-list>

    <!-- 장문형 -->
    <lp-editor v-else-if="param.param_type===14" :text.sync="param.value_long_text"></lp-editor>
  </div>
</template>

<script>
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import LpCheckBool from '../../module/common/LpCheckBool'
  import { SweetModal } from 'sweet-modal-vue'
  import LpModal from '../../module/common/LpModal.vue'
  import LpAddress from "../common/LpAddress";
  import LpCheckGroup from "../common/LpCheckGroup";
  import LpRegionDropDown from "../common/LpRegionDropDown";
  import LpLinear from "../common/LpLinear";
  import AdminDatePicker from "../admin/AdminDatePicker";
  import moment from 'moment'
  import InputFile from "../common/InputFile";
  import AdminTimePicker from "../admin/AdminTimePicker";
  import LpEditor from "../common/LpEditor";
  import OldInputFile from "../common/OldInputFile";
  import TimePicker from "../common/TimePicker";
  import LpAddressList from "../common/LpAddressList";
  import LpMultipleColorInput from "../common/LpMultipleColorInput";

  export default {
    props:['param'],
    components: {
      LpMultipleColorInput,
      LpAddressList,
      TimePicker,
      OldInputFile,
      LpEditor,
      AdminTimePicker,
      InputFile,
      AdminDatePicker,
      LpLinear,
      LpRegionDropDown,
      LpCheckGroup,
      LpAddress,
      LpInputText, LpRadio, LpCheckBool, LpModal, LpSortDropDown, SweetModal
    },
    watch: {

    },
    data () {
      return {
      }
    },
    created() {
      if(this.param.param_type===5 && !this.param.value_address) {
        this.param.value_address = {
          sido: '',
          sigungu: '',
          dong: '',
          detail: '',
          post_code: '',
          old: '',
          new: ''
        }
      }
    },
    methods: {
      selectRadioValue(value, param){
        param.value_select = [value];
      },
      selectedRadioValue(value){
        //console.log(value)
        if (value) {
          return value[0];
        }
        else {
          return ''
        }
      },
      selDate(value) {
        this.param.value_date = value;
      },
      selDateTime(value) {
        this.param.value_date_time = value;
      },
      selDateRange(value) {
        this.param.value_date_range = value;
      },
      selDateTimeRange(value) {
        this.param.value_date_time_range = value;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/lp_main'

</style>
